import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import StatsCard from './StatsCard';
import { useAuth } from '../../context/AuthContext';
import '../../styles/dashboard.css';

const formatCurrency = (amount) => {
  if (amount === undefined || amount === null) return 'KSh 0';
  return new Intl.NumberFormat('en-KE', {
    style: 'currency',
    currency: 'KES',
    minimumFractionDigits: 0
  }).format(amount).replace('KES', 'KSh');
};

const CashierDashboard = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState({
    totalSales: 0,
    transactions: 0,
    uniqueCustomers: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadMySales();
  }, []);

  const loadMySales = async () => {
    try {
      const response = await api.get('/reports.php/my-sales');
      
      if (response.data) {
        setStats({
          totalSales: response.data.total_sales,
          transactions: response.data.transaction_count,
          uniqueCustomers: response.data.unique_customers
        });
      }
    } catch (error) {
      console.error('Failed to load cashier stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading your sales data...</p>
      </div>
    );
  }

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1>My Dashboard</h1>
        <div className="date-range">
          <span>Today</span>
        </div>
      </div>

      <div className="stats-grid">
        <StatsCard
          title="My Total Sales Today"
          value={formatCurrency(stats.totalSales)}
          icon="💰"
        />
        <StatsCard
          title="My Transactions"
          value={stats.transactions || 0}
          icon="🛒"
        />
        <StatsCard
          title="Customers Served"
          value={stats.uniqueCustomers || 0}
          icon="👥"
        />
      </div>

      <div className="dashboard-row" style={{ marginTop: '2rem' }}>
        <div className="chart-card">
          <h3>Welcome, {user?.first_name}!</h3>
          <p>This is your personal dashboard. From here you can navigate to the POS to make sales.</p>
        </div>
      </div>
    </div>
  );
};

export default CashierDashboard;
